import React, { useState } from "react";
import api from "../../services/api";
import "./auth.css"; // reuse auth styles
import { FaEye, FaEyeSlash, FaLock, FaCheckCircle, FaExclamationCircle } from "react-icons/fa";
import { formatCNIC, isValidCNIC  } from "../../utils/formatCNIC";

const ActivateAccount = ({ onActivateSuccess }) => {
  const [form, setForm] = useState({ cnic: "", email: "", password: "" });
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    if (e.target.name === "cnic") {
      const formatted = formatCNIC(e.target.value);
      setForm({ ...form, cnic: formatted });
    } else {
      setForm({ ...form, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    if (!isValidCNIC(form.cnic)) {
      setErrorMsg("Invalid CNIC format. Use: 12345-1234567-1");
      return;
    }
    
    try {
      setIsLoading(true);
      const res = await api.post("/auth/activate", form);
      setSuccessMsg(res.data.message);
      setTimeout(() => onActivateSuccess(), 2000);
    }
     catch (err) {
      setErrorMsg(err.response?.data?.message || "Activation failed");
    }
     finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h2 className="auth-title"><FaLock style={{ marginRight: "8px" }} />Activate Your Account</h2>
          <p className="auth-subtitle">Set your password to start using the system</p>
        </div>
        <div className="auth-body">
          {successMsg && <div className="success-message"><FaCheckCircle style={{ marginRight: "6px" }} />{successMsg}</div>}
          {errorMsg && <div className="error-message"><FaExclamationCircle style={{ marginRight: "6px" }} />{errorMsg}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">CNIC</label>
              <input type="text" name="cnic" className="form-input" value={form.cnic} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <input type="email" name="email" className="form-input" value={form.email} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label className="form-label">New Password</label>
              <div className="password-input-wrapper">
                <input type={showPassword ? "text" : "password"} name="password" className="form-input" value={form.password} onChange={handleChange} minLength={6} required />
                <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() => setShowPassword(!showPassword)}
                    >
                    {showPassword ? <FaEye /> : <FaEyeSlash />}
                  </button>
              </div>
            </div>
            <button type="submit" className="btn-submit" disabled={isLoading}>
              {isLoading ? "Activating..." : "Set Password"}
            </button>
          </form>
          <p className="auth-footer-text">
            Already activated? <a href="/login">Sign in</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ActivateAccount;